import { memo } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { Select } from 'foundations-components/transitional/components/Select';
import FilterOperatorDateInput from './FilterOperatorDateInput';
import FilterOperatorRollingDatePointInput from './FilterOperatorRollingDatePointInput';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import { DYNAMIC, STATIC } from '../../types/operator/RollingDatePointType';
import I18n from 'I18n';
import RollingDatePointConfig from '../../filterQueryFormat/rollingDates/RollingDatePointConfig';
import { TODAY } from '../../filterQueryFormat/rollingDates/RollingDatePointOptionValues';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorDateStaticOrDynamicInput = props => {
  const {
    condition,
    onChange,
    inputUse
  } = props;
  const options = [{
    text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.staticOrDynamicDate.static'),
    value: STATIC
  }, {
    text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.staticOrDynamicDate.dynamic'),
    value: DYNAMIC
  }];
  const handleOperatorChange = evt => {
    const isChangingToStatic = evt.target.value.value === STATIC;
    if (isChangingToStatic) {
      onChange(syntheticEvent(condition.set('value', undefined).set('type', STATIC)));
    } else {
      onChange(syntheticEvent(condition.set('value', RollingDatePointConfig.fromRollingDatePointOptionValue(TODAY)).set('type', DYNAMIC)));
    }
  };
  const handleStaticChange = evt => {
    const newValue = evt.target.value;
    onChange(syntheticEvent(condition.set('value', newValue).set('type', STATIC)));
  };
  const handleDynamicChange = evt => {
    const newValue = evt.target.value;
    onChange(syntheticEvent(condition.set('value', newValue.value).set('type', DYNAMIC)));
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(Select, {
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
        onSelectedOptionChange: handleOperatorChange,
        options: options,
        value: condition.type
      })
    }), condition.type === STATIC ? /*#__PURE__*/_jsx(FilterOperatorDateInput, Object.assign({}, props, {
      fieldType: DATE,
      value: condition && condition.value,
      onChange: handleStaticChange
    })) : /*#__PURE__*/_jsx(FilterOperatorRollingDatePointInput, Object.assign({}, props, {
      condition: condition,
      onChange: handleDynamicChange
    }))]
  });
};
export default /*#__PURE__*/memo(FilterOperatorDateStaticOrDynamicInput);